import React, { useEffect } from 'react';
import ObjectInfoPhoto from '../images/ObjectInfo.png';
import styled from 'styled-components';

const StyledContainer = styled.div`
width: 100%;
margin: auto;
padding: 10px 0px 10px 0px;
`;

const ObjectInfoPage = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontSize: "18px" }}>
        <div style={{ fontSize: "32px", fontWeight: "bold", marginTop: '10px'}}>
        Object Info
        </div>
        <div style={{ margin: '10px 0px' }}>
        To view object info, click Object Info tab, move the mouse over the object in the view. The object info will be displayed in Object Info panel. 
        </div>

        <StyledContainer>
            <img src={ObjectInfoPhoto} style={{width: '100%', height: 'auto', border: '1px solid gray'}} alt="" />
        </StyledContainer>

    </div>
  )
}

export default ObjectInfoPage;